import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';

//UI
import {
  DangerButton,
  PrimaryButton,
  SuccessButton,
} from "../../../../ui/buttons/Button";
import {
  Checkbox,
  Input,
  Radio,
  SearchInput,
  Select,
  Textarea,
} from "../../../../ui/inputs/Input";

import TablaFamiliares from "./Tablas/TablaFamiliares";
import TablaVacaciones from "./Tablas/TablaVacaciones";
import TablaConceptoNomina from "./Tablas/TablaConceptoNomina";
import TablaConstantesNomina from "./Tablas/TablaConstantesNomina";
import TablaVisualizarNomina from './Tablas/TablaVisualizarNomina';
import TablaAcumuGenerales from "./Tablas/TablaAcumualcionesGenerales";
import TablaConceptosPagos from "./Tablas/TablaConceptosPagos";
import TablaDatosLaborales from "./Tablas/TablaDatosLaborales";
import CatalogoUnidadFuncional from "../../../../catalogos/catalogoUnidadFuncional";
import CatalogoDepartamento from "../../../../catalogos/catalogoDepartamento";
import CatalogoCargo from "../../../../catalogos/catalogoCargo";
import CatalogoBancoNomina from "../../../../catalogos/catalogoBancoNomina";
import CatalogoGrupoNomina from "../../../../catalogos/catalogoGrupoNomina";

export default function Integrantes(props) {
  var op = require('../../../../../src/modulos/datos');

  let token = localStorage.getItem('jwtToken');
  const [activate, setActivate] = useState(false);

  // Estados para la foto
  const [foto, setFoto] = useState(null);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [fotoNombre, setFotoNombre] = useState("");
  const fileInputRef = useRef(null);

  // Estados para los selects
  const [gradoInstruccion, setGradoInstruccion] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [menciones, setMenciones] = useState([]);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [mostrarUnidadFuncional, setMostrarUnidadFuncional] = useState(false);
  const [mostrarDepartamento, setMostrarDepartamento] = useState(false);
  const [mostrarCargo, setMostrarCargo] = useState(false);
  const [mostrarBanco, setMostrarBanco] = useState(false);
  const [mostrarGrupoNomina, setMostrarGrupoNomina] = useState(false);

  // Estados para datos locales de tablas (operacion 1 - INCLUIR)
  const [datosLocales, setDatosLocales] = useState({
    familiares: [],
    cargos: [],
    cursos: [],
    profesiones: [],
    vacaciones: [],
    constantes: [],
    conceptos: [],
    conceptosPagos: [],
    acumulados: []
  });

  // Estado para los datos del integrante
  const [integrante, setIntegrante] = useState({
    codIntegrante: "",
    cedula: "",
    rif: "V-00000000-0",
    correo: "",
    nombres: "",
    apellidos: "",
    fechaNacimiento: "",
    edad: "",
    estadoCivil: "1",
    sexo: "1",
    direccion: "",
    telefono: "",
    telefonoContacto: "",
    idEstado: "",
    idMunicipio: "",
    idCiudad: "",
    idLocalidad: "",
    nacionalidad: "VENEZOLANA",
    grupoSanguineo: "",
    estatura: "",
    peso: "",
    usaLentes: "2",
    tallaCalzado: "",
    tallaPantalon: "",
    tallaCamisa: "",
    discapacitado: "2",
    codConapdis: "",
    patologia: "",
    foto: "",

    // Datos laborales
    codUnidadFuncional: "",
    nombreUnidadFuncional: "",
    codDepartamento: "",
    nombreDepartamento: "",
    codCargo: "",
    nombreCargo: "",
    status: "Activo",
    fechaIngreso: "",
    antiguedad: "",

    // Datos banco
    pagadoBanco: false,
    codBanco: "",
    nombreBanco: "",
    tipoCuenta: "1",
    numCuenta: "",
    desCuenta: "",
    codFideicomiso: "",
    nombreFideicomiso: "",
    numCuentaFideicomiso: "",

    // Datos nómina
    codGrupoNomina: "",
    nombreGrupoNomina: "",
    fecUltVacaciones: "",
    fecIngresoVacaciones: "",
    fecAdmonPublica: "",
    vacacionesVencidas: "0",
    diasVacPendientes: "0",
    fechaEgreso: "",
    motivoEgreso: "",
    salarioMensual: "",
    
    // IDs para selects
    idGrado: "",
    idEspecialidad: "",
    idMencion: ""
  });

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const salir = () => {
    // Limpiar la vista previa de la foto
    if (fotoPreview) {
      URL.revokeObjectURL(fotoPreview);
    }

    // Resetear todos los campos
    resetearTodo();

    // Cerrar el modal
    props.cerrarModal();
  };

  // Función para recibir datos de las tablas hijas (modo local)
  const handleDataFromChild = (tipo, data) => {
    console.log(tipo, data);
    setDatosLocales(prev => ({
      ...prev,
      [tipo]: data
    }));
  };

  // Función para preparar arredat (array con todos los datos adicionales)
  const prepararArredat = () => {
    return [
      integrante.cedula || '',
      integrante.sexo || '1',
      integrante.estadoCivil || '1',
      integrante.usaLentes || '2',
      integrante.tallaCalzado || '',
      integrante.tallaCamisa || '',
      integrante.tallaPantalon || '',
      integrante.vacacionesVencidas || '0',
      integrante.diasVacPendientes || '0',
      integrante.rif || 'V-00000000-0',
      integrante.nacionalidad || 'VENEZOLANA',
      integrante.tipoCuenta || '1',
      integrante.fecAdmonPublica || '',
      integrante.correo || '',
      integrante.discapacitado || '2',
      integrante.codConapdis || ''
    ];
  };

  // Función para formatear salario (quitar formato de moneda)
  const formatearSalarioParaBD = (salario) => {
    if (!salario) return 0;
    if (typeof salario === 'string') {
      return parseFloat(salario.replace(/\./g, '').replace(/,/g, '.'));
    }
    return parseFloat(salario) || 0;
  };

  // Función para guardar todo con la nueva estructura JSONB
  const guardarTodo = async () => {
    if (props.operacion === 1 || props.operacion === 2) {
      // Crear FormData
      const formData = new FormData();

      // Obtener esquema
      const codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
      const esquema = `nomi${codigoNomina}`;

      // Preparar el array arredat
      const arredatArray = prepararArredat();

      // Crear el objeto del integrante con TODOS los campos (UN SOLO OBJETO)
      const integranteObj = {
        p_esquema1: esquema,
        p_ccodint: integrante.codIntegrante,
        p_capeint: integrante.apellidos || '',
        p_cnomint: integrante.nombres || '',
        p_cgrusan: integrante.grupoSanguineo || '',
        p_dfecnac: integrante.fechaNacimiento || null,
        p_ctlfint: integrante.telefono || '',
        p_cdirint: integrante.direccion || '',
        p_ccoduni: integrante.codUnidadFuncional || '',
        p_ccoddep: integrante.codDepartamento || '',
        p_ccodcar: integrante.codCargo || '',
        p_naltura: parseFloat(integrante.estatura) || 0,
        p_npeso: parseFloat(integrante.peso) || 0,
        p_dfecing: integrante.fechaIngreso || null,
        p_dfecegre: integrante.fechaEgreso || null,
        p_nsalmen: formatearSalarioParaBD(integrante.salarioMensual) || 0,
        p_cstatus: integrante.status || 'Activo',
        p_bpagban: integrante.pagadoBanco || false,
        p_ccodban: integrante.codBanco || '',
        p_cnumcueban: integrante.numCuenta || '',
        p_ctipocue: integrante.desCuenta || '',
        p_ccodfide: integrante.codFideicomiso || '',
        p_cnumcuefide: integrante.numCuentaFideicomiso || '',
        p_cgrunom: integrante.codGrupoNomina || '',
        p_dfecultvac: integrante.fecUltVacaciones || null,
        p_dfecingvac: integrante.fecIngresoVacaciones || null,
        p_cfoto: foto ? foto.name : (integrante.foto || ''),
        p_dfecret: null,
        p_dfecsal: null,
        p_cmotegre: integrante.motivoEgreso || '',
        p_ctlfintcont: integrante.telefonoContacto || '',
        p_patoloint: integrante.patologia || '',
        p_menci: parseInt(integrante.idMencion) || 0,
        p_ciud: integrante.idCiudad || '',
        p_locali: integrante.idLocalidad || '',
        p_arredat: arredatArray  // El array arredat va DENTRO del objeto integrante
      };

      // Crear el objeto completo para enviar (ahora con arrays)
      const datosEnvio = {
        p_integrante: [integranteObj],  // Array con un solo objeto (el integrante principal)
        p_familiares: props.operacion === 1 ? datosLocales.familiares : [],
        p_cargos: props.operacion === 1 ? datosLocales.cargos : [],
        p_cursos: props.operacion === 1 ? datosLocales.cursos : [],
        p_profesiones: props.operacion === 1 ? datosLocales.profesiones : []
      };

      console.log('Datos a enviar (JSONB):', JSON.stringify(datosEnvio, null, 2));

      // Agregar los datos al FormData como string JSON
      formData.append('datos', JSON.stringify(datosEnvio));

      // Agregar foto si existe
      if (foto) {
        formData.append('foto', foto);
        console.log('Foto adjuntada:', foto.name, foto.type, foto.size);
      }

      try {
        setActivate(true);

        const response = await axios.post(
          `${op.conexion}/api/nomina/integrante_completo_act?operacion=${props.operacion}`,
          formData,
          {
            headers: {
              "x-access-token": token,
              "Content-Type": "multipart/form-data"
            }
          }
        );

        console.log('Respuesta del servidor:', response.data);

        if (response.status === 200 && response.data.success) {
          setMensaje({
            mostrar: true,
            titulo: 'Éxito',
            texto: response.data.message || 'Operación realizada con éxito',
            icono: 'success'
          });

          setTimeout(() => {
            if (fotoPreview) {
              URL.revokeObjectURL(fotoPreview);
            }
            resetearTodo();
            props.cerrarModal();
            if (props.onRefresh) {
              props.onRefresh();
            }
          }, 2000);
        } else {
          setMensaje({
            mostrar: true,
            titulo: 'Error',
            texto: response.data.message || 'Error al procesar la solicitud',
            icono: 'error'
          });
        }
      } catch (error) {
        console.error('Error completo:', error);
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || error.response?.data?.error || error.message || 'Error al guardar el integrante',
          icono: 'error'
        });
      } finally {
        setActivate(false);
      }
    } else {
      props.cerrarModal();
    }
  };

  // Función para consultar integrante completo
  const consultarIntegranteCompleto = async (codint) => {
    try {
      setActivate(true);

      const codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
      const esquema = `nomi${codigoNomina}`;

      const response = await axios.get(
        `${op.conexion}/api/nomina/integrante_completo_consultar?codint=${codint}&esquema=${esquema}`,
        {
          headers: { "x-access-token": token }
        }
      );

      if (response.status === 200 && response.data.success) {
        const { integrante, familiares, cargos, cursos, profesiones } = response.data.data;

        console.log('Datos completos:', { integrante, familiares, cargos, cursos, profesiones });

        setDatosLocales({
          ...datosLocales,
          familiares: familiares || [],
          cargos: cargos || [],
          cursos: cursos || [],
          profesiones: profesiones || []
        });

        return response.data.data;
      }
    } catch (error) {
      console.error('Error al consultar:', error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || 'Error al consultar el integrante',
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  // FORMATEO DE FECHAS
  const formatearFecha = (fecha) => {
    if (!fecha) return "";
    if (fecha.includes('/')) {
      const [dia, mes, anio] = fecha.split('/');
      return `${anio}-${mes}-${dia}`;
    }
    return fecha;
  };

  const formatearFechaParaBD = (fecha) => {
    if (!fecha) return "";
    if (fecha.includes('-')) {
      const [anio, mes, dia] = fecha.split('-');
      return `${dia}/${mes}/${anio}`;
    }
    return fecha;
  };

  // FORMATEO DE MONTOS
  const formatearMonto = (valor) => {
    if (!valor) return "0,00";
    return new Intl.NumberFormat('es-VE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(valor).replace(/\./g, ',');
  };

  // CALCULAR EDAD
  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return "";
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      edad--;
    }
    return edad;
  };

  // CALCULAR ANTIGÜEDAD
  const calcularAntiguedad = (fechaIngreso, fechaEgreso = null) => {
    if (!fechaIngreso) return "";

    const inicio = new Date(fechaIngreso);
    const fin = fechaEgreso ? new Date(fechaEgreso) : new Date();

    let años = fin.getFullYear() - inicio.getFullYear();
    let meses = fin.getMonth() - inicio.getMonth();
    let dias = fin.getDate() - inicio.getDate();

    if (dias < 0) {
      meses--;
      dias += new Date(fin.getFullYear(), fin.getMonth(), 0).getDate();
    }

    if (meses < 0) {
      años--;
      meses += 12;
    }

    return `${años} Años ${meses} Meses ${dias} Días`;
  };

  // FUNCIONES PARA MANEJO DE FOTO
  const handleFotoClick = () => {
    fileInputRef.current.click();
  };

  const handleFotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const extensionesValidas = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp'];
    if (!extensionesValidas.includes(file.type)) {
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: 'Formato no válido. Use JPG, PNG, GIF o BMP',
        icono: 'error'
      });
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: 'La imagen es muy grande. Máximo 2MB',
        icono: 'error'
      });
      return;
    }

    setFoto(file);
    setFotoNombre(file.name);

    const reader = new FileReader();
    reader.onloadend = () => {
      setFotoPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  // SELECCIONAR GRADO INSTRUCCIÓN
  const seleccionarGinstruc = () => {
    const campos = "*";
    const nomtab = "gradoinstruccion";
    const orden = "idgradoinstruccion";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setGradoInstruccion(response.data);
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response?.data?.message || "Error al cargar grados",
          icono: "error"
        });
      })
      .finally(() => setActivate(false));
  };

  // SELECCIONAR ESPECIALIDADES
  const seleccionarEspecialidades = (idGrado) => {
    if (!idGrado) return;

    const endpoint = `${op.conexion}/api/nomina/seleccionespecialidades?idgrado=${idGrado}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setEspecialidades(response.data);
        }
      })
      .catch(error => {
        console.error("Error cargando especialidades:", error);
      })
      .finally(() => setActivate(false));
  };

  // SELECCIONAR MENCIONES
  const seleccionarMenciones = (idEspecialidad) => {
    if (!idEspecialidad) return;

    const endpoint = `${op.conexion}/api/nomina/seleccionmenciones?idespecialidad=${idEspecialidad}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setMenciones(response.data);
        }
      })
      .catch(error => {
        console.error("Error cargando menciones:", error);
      })
      .finally(() => setActivate(false));
  };

  // SELECCIONAR ESTADOS
  const seleccionarEstados = () => {
    const campos = "*";
    const nomtab = "estado";
    const orden = "idestado";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setEstados(response.data);
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response?.data?.message || "Error al cargar estados",
          icono: "error"
        });
      })
      .finally(() => setActivate(false));
  };

  // SELECCIONAR MUNICIPIOS
  const seleccionarMunicipios = (idEstado) => {
    if (!idEstado) return;

    const endpoint = `${op.conexion}/api/nomina/seleccionmunicipios?idestado=${idEstado}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setMunicipios(response.data);
        }
      })
      .catch(error => {
        console.error("Error cargando municipios:", error);
      })
      .finally(() => setActivate(false));
  };

  // SELECCIONAR CIUDADES
  const seleccionarCiudades = (idMunicipio) => {
    if (!idMunicipio) return;

    const endpoint = `${op.conexion}/api/nomina/seleccionciudades?idmunicipio=${idMunicipio}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setCiudades(response.data);
        }
      })
      .catch(error => {
        console.error("Error cargando ciudades:", error);
      })
      .finally(() => setActivate(false));
  };

  // SELECCIONAR LOCALIDADES
  const seleccionarLocalidades = (idCiudad) => {
    if (!idCiudad) return;

    const endpoint = `${op.conexion}/api/nomina/seleccionlocalidades?idciudad=${idCiudad}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setLocalidades(response.data);
        }
      })
      .catch(error => {
        console.error("Error cargando localidades:", error);
      })
      .finally(() => setActivate(false));
  };

  // SELECCIONAR UNIDAD FUNCIONAL
  const seleccionarUnidadFuncional = (codigo) => {
    if (!codigo) return;
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let nomtab = 'unidadfuncional';
    let nomid = 'coduni';
    let bloquear = true;
    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}&bloquear=${bloquear}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          setIntegrante(prev => ({
            ...prev,
            nombreUnidadFuncional: response.data[0].nomuni || ""
          }));
        }
      })
      .catch(error => console.error("Error cargando unidad funcional:", error))
      .finally(() => setActivate(false));
  };

  // SELECCIONAR DEPARTAMENTO
  const seleccionarDepartamento = (codigo) => {
    if (!codigo) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let nomtab = 'departamento';
    let nomid = 'coddep';
    let bloquear = true;

    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}&bloquear=${bloquear}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          setIntegrante(prev => ({
            ...prev,
            nombreDepartamento: response.data[0].nomdep || ""
          }));
        }
      })
      .catch(error => console.error("Error cargando departamento:", error))
      .finally(() => setActivate(false));
  };

  // SELECCIONAR CARGO
  const seleccionarCargo = (codigo) => {
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let nomtab = 'cargo';
    let nomid = 'codcar';
    let bloquear = true;

    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}&bloquear=${bloquear}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          setIntegrante(prev => ({
            ...prev,
            nombreCargo: response.data[0].nomcar || "",
            salarioMensual: formatearMonto(response.data[0].sueldo)
          }));
        }
      })
      .catch(error => console.error("Error cargando cargo:", error))
      .finally(() => setActivate(false));
  };

  // SELECCIONAR BANCO
  const seleccionarBanco = (codigo) => {
    if (!codigo) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let nomtab = 'banco';
    let nomid = 'codban';
    let bloquear = true;
    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}&bloquear=${bloquear}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          setIntegrante(prev => ({
            ...prev,
            nombreBanco: response.data[0].nomban || ""
          }));
        }
      })
      .catch(error => console.error("Error cargando banco:", error))
      .finally(() => setActivate(false));
  };

  // SELECCIONAR GRUPO NOMINA
  const seleccionarGrupoNomina = (codigo) => {
    if (!codigo) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let nomtab = 'gruposnomina';
    let nomid = 'codgru';
    let bloquear = true;
    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}&bloquear=${bloquear}`;
    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          setIntegrante(prev => ({
            ...prev,
            nombreGrupoNomina: response.data[0].nomgru || ""
          }));
        }
      })
      .catch(error => console.error("Error cargando grupo nómina:", error))
      .finally(() => setActivate(false));
  };

  // SELECCIONAR NOMBRE CIUDAD
  const seleccionarnombreciudad = (id) => {
    if (!id) return;

    let endpoint = `${op.conexion}/api/nomina/seleccionarnombreciudad?id=${id}`;
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          setIntegrante(prev => ({
            ...prev,
            idCiudad: id,
            ciudadNombre: response.data[0].nombre
          }));
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response?.data?.message || "Error al cargar ciudad",
          icono: "error"
        });
      });
  };

  // SELECCIONAR NOMBRE LOCALIDAD
  const seleccionarnombrelocalidad = (id) => {
    if (!id) return;

    let endpoint = `${op.conexion}/api/nomina/seleccionarnombrelocalidad?id=${id}`;
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          setIntegrante(prev => ({
            ...prev,
            idLocalidad: id,
            localidadNombre: response.data[0].nombre
          }));
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response?.data?.message || "Error al cargar localidad",
          icono: "error"
        });
      });
  };

  // SELECCIONAR NOMBRE MENCION
  const seleccionarnombremencion = (idmencio) => {
    let campos = "gradoinstruccion.idgradoinstruccion,gradoinstruccion.descripcion,especialidad.descripcion as nomesp,mencion.descripcion as nommenc";
    let nomtab = "especialidad , mencion,gradoinstruccion ";
    let nomid = "especialidad.idgradoinstruccion = gradoinstruccion.idgradoinstruccion and especialidad.idespecialidad = mencion.idespecialidad and mencion.idmencion";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idmencio}&nomtab=${nomtab}&nomid=${nomid}`;

    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          const data = response.data[0];
          const gradoSelect = document.querySelector('select[aria-label="Grado de Instrucción:"]');
          if (gradoSelect) {
            setTimeout(() => {
              for (let i = 0; i < gradoSelect.options.length; i++) {
                if (gradoSelect.options[i].text === data.descripcion) {
                  gradoSelect.selectedIndex = i;
                  const event = new Event('change', { bubbles: true });
                  gradoSelect.dispatchEvent(event);
                  break;
                }
              }
            }, 500);
          }
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response?.data?.message,
          icono: "error"
        });
      });
  };

  // SELECCIONAR REGISTRO PRINCIPAL
  const seleccionarRegistro = async (id) => {
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let nomtab = 'integrantes';
    let nomid = 'codint';
    let bloquear = true;

    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&bloquear=${bloquear}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data[0]) {
          const data = response.data[0];

          setIntegrante({
            // Datos personales
            codIntegrante: data.codint || "",
            cedula: data.cedint || "",
            rif: data.rif || "V-00000000-0",
            correo: data.correoe || "",
            nombres: data.nombre || "",
            apellidos: data.apellido || "",
            fechaNacimiento: formatearFecha(data.fecnac),
            edad: calcularEdad(data.fecnac),
            estadoCivil: data.edociv?.toString() || "1",
            sexo: data.sexo?.toString() || "1",
            direccion: data.dirint || "",
            telefono: data.tlfint || "",
            telefonoContacto: data.tlfintcont || "",
            idEstado: data.idestado || "",
            idMunicipio: data.idmunicipio || "",
            idCiudad: data.idciudad || "",
            idLocalidad: data.idlocalidad || "",
            nacionalidad: data.nacint || "VENEZOLANA",
            grupoSanguineo: data.grusan || "",
            estatura: data.altura || "",
            peso: data.peso || "",
            usaLentes: data.usalen?.toString() || "2",
            tallaCalzado: data.tallacal || "",
            tallaPantalon: data.tallapan || "",
            tallaCamisa: data.tallacam || "",
            discapacitado: data.discapacitado?.toString() || "2",
            codConapdis: data.codconapdis || "",
            patologia: data.patologia || "",
            foto: data.foto || "",

            // Datos laborales
            codUnidadFuncional: data.coduni || "",
            nombreUnidadFuncional: "",
            codDepartamento: data.coddep || "",
            nombreDepartamento: "",
            codCargo: data.codcar || "",
            nombreCargo: "",
            status: data.status || "Activo",
            fechaIngreso: formatearFecha(data.fecing),
            antiguedad: calcularAntiguedad(data.fecing, data.fecegre),

            // Datos banco
            pagadoBanco: data.pagban === 1 || data.pagban === true,
            codBanco: data.codban || "",
            nombreBanco: "",
            tipoCuenta: data.tipocuenta?.toString() || "1",
            numCuenta: data.numcueban || "",
            desCuenta: data.tipocue || "",
            codFideicomiso: data.codfide || "",
            nombreFideicomiso: "",
            numCuentaFideicomiso: data.numcuefide || "",

            // Datos nómina
            codGrupoNomina: data.grunom || "",
            nombreGrupoNomina: "",
            fecUltVacaciones: formatearFecha(data.fecultvac),
            fecIngresoVacaciones: formatearFecha(data.fecingvac),
            fecAdmonPublica: formatearFecha(data.fecingadmonpub),
            vacacionesVencidas: data.vacven || "0",
            diasVacPendientes: data.diasvacacu || "0",
            fechaEgreso: formatearFecha(data.fecegre),
            motivoEgreso: data.motegre || "",
            salarioMensual: formatearMonto(data.salmen),
            
            // IDs para selects
            idGrado: "",
            idEspecialidad: "",
            idMencion: ""
          });

          if (data.foto) {
            cargarFoto(data.foto);
          }

          if (parseInt(data.mencion)) {
            seleccionarnombremencion(data.mencion);
          }

          if (parseInt(data.idestado)) {
            setTimeout(() => seleccionarMunicipios(data.idestado), 100);
          }

          if (parseInt(data.idmunicipio)) {
            setTimeout(() => seleccionarCiudades(data.idmunicipio), 200);
          }

          if (parseInt(data.idciudad)) {
            setTimeout(() => seleccionarLocalidades(data.idciudad), 300);
            seleccionarnombreciudad(data.idciudad);
          }

          if (parseInt(data.idlocalidad)) {
            seleccionarnombrelocalidad(data.idlocalidad);
          }

          setTimeout(() => {
            seleccionarUnidadFuncional(data.coduni);
            seleccionarDepartamento(data.coddep);
            seleccionarCargo(data.codcar);
            seleccionarBanco(data.codban);
            seleccionarGrupoNomina(data.grunom);
          }, 100);

          if (props.operacion === 4) {
            consultarIntegranteCompleto(id);
          }
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || 'Error al cargar el registro',
          icono: 'error'
        });
      })
      .finally(() => setActivate(false));
  };

  // Función para cargar foto desde el servidor
  const cargarFoto = (nombreFoto) => {
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let urlFoto = `${op.conexion}/uploads/nomi${codigoNomina}/${nombreFoto}`;

    axios.get(urlFoto, {
      headers: { "x-access-token": `${token}` },
      responseType: 'blob'
    })
      .then(response => {
        if (response.status === 200) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setFotoPreview(reader.result);
          };
          reader.readAsDataURL(response.data);
          setFotoNombre(nombreFoto);
        }
      })
      .catch(error => {
        console.log("No se pudo cargar la foto:", error);
      });
  };

  // Cargar datos iniciales al abrir el modal
  useEffect(() => {
    if (props.show && props.id) {
      seleccionarGinstruc();
      seleccionarEstados();
      seleccionarRegistro(props.id);
    } else if (props.show && props.operacion === 1) {
      seleccionarGinstruc();
      seleccionarEstados();
    }

    return () => {
      if (fotoPreview) {
        URL.revokeObjectURL(fotoPreview);
      }
    };
  }, [props.show, props.id]);

  // Actualizar nombre de unidad funcional cuando cambia el código
  useEffect(() => {
    if (integrante.codUnidadFuncional) {
      seleccionarUnidadFuncional(integrante.codUnidadFuncional);
    }
  }, [integrante.codUnidadFuncional]);

  // Actualizar nombre de departamento cuando cambia el código
  useEffect(() => {
    if (integrante.codDepartamento) {
      seleccionarDepartamento(integrante.codDepartamento);
    }
  }, [integrante.codDepartamento]);

  // Actualizar nombre de cargo cuando cambia el código
  useEffect(() => {
    if (integrante.codCargo) {
      seleccionarCargo(integrante.codCargo);
    }
  }, [integrante.codCargo]);

  // Actualizar nombre de banco cuando cambia el código
  useEffect(() => {
    if (integrante.codBanco) {
      seleccionarBanco(integrante.codBanco);
    }
  }, [integrante.codBanco]);

  // Actualizar nombre de grupo nómina cuando cambia el código
  useEffect(() => {
    if (integrante.codGrupoNomina) {
      seleccionarGrupoNomina(integrante.codGrupoNomina);
    }
  }, [integrante.codGrupoNomina]);

  // Manejar cambios en los inputs
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setIntegrante(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Manejar cambio de estado
  const handleEstadoChange = (e) => {
    const idEstado = e.target.value;
    setIntegrante(prev => ({ ...prev, idEstado, idMunicipio: "", idCiudad: "", idLocalidad: "" }));
    setMunicipios([]);
    setCiudades([]);
    setLocalidades([]);
    if (idEstado) seleccionarMunicipios(idEstado);
  };

  // Manejar cambio de municipio
  const handleMunicipioChange = (e) => {
    const idMunicipio = e.target.value;
    setIntegrante(prev => ({ ...prev, idMunicipio, idCiudad: "", idLocalidad: "" }));
    setCiudades([]);
    setLocalidades([]);
    if (idMunicipio) seleccionarCiudades(idMunicipio);
  };

  // Manejar cambio de ciudad
  const handleCiudadChange = (e) => {
    const idCiudad = e.target.value;
    setIntegrante(prev => ({ ...prev, idCiudad, idLocalidad: "" }));
    setLocalidades([]);
    if (idCiudad) {
      seleccionarLocalidades(idCiudad);
      seleccionarnombreciudad(idCiudad);
    }
  };

  // Manejar cambio de localidad
  const handleLocalidadChange = (e) => {
    const idLocalidad = e.target.value;
    setIntegrante(prev => ({ ...prev, idLocalidad }));
    if (idLocalidad) seleccionarnombrelocalidad(idLocalidad);
  };

  // Manejar cambio de grado instrucción
  const handleGradoChange = (e) => {
    const idGrado = e.target.value;
    setIntegrante(prev => ({ ...prev, idGrado }));
    setEspecialidades([]);
    setMenciones([]);
    if (idGrado) seleccionarEspecialidades(idGrado);
  };

  // Manejar cambio de especialidad
  const handleEspecialidadChange = (e) => {
    const idEspecialidad = e.target.value;
    setIntegrante(prev => ({ ...prev, idEspecialidad }));
    setMenciones([]);
    if (idEspecialidad) seleccionarMenciones(idEspecialidad);
  };

  const onHideAceptaUnidadFuncional = (values) => {
    setMostrarUnidadFuncional(false);
    setIntegrante(prev => ({
      ...prev,
      codUnidadFuncional: values.coduni,
      nombreUnidadFuncional: values.nomuni
    }));
  }

  const onHideAceptaDepartamento = (values) => {
    setMostrarDepartamento(false);
    setIntegrante(prev => ({
      ...prev,
      codDepartamento: values.coddep,
      nombreDepartamento: values.nomdep
    }));
  }

  const onHideAceptaCargo = (values) => {
    setMostrarCargo(false);
    setIntegrante(prev => ({
      ...prev,
      codCargo: values.codcar,
      nombreCargo: values.nomcar,
      salarioMensual: formatearMonto(values.sueldo)
    }));
  }

  const onHideAceptaBanco = (values) => {
    setMostrarBanco(false);
    setIntegrante(prev => ({
      ...prev,
      codBanco: values.codban,
      nombreBanco: values.nomban
    }));
  }

  const onHideAceptaGrupoNomina = (values) => {
    setMostrarGrupoNomina(false);
    setIntegrante(prev => ({
      ...prev,
      codGrupoNomina: values.codgru,
      nombreGrupoNomina: values.nomgru
    }));
  }

  // Función para resetear todos los campos
  const resetearTodo = () => {
    setIntegrante({
      codIntegrante: "",
      cedula: "",
      rif: "V-00000000-0",
      correo: "",
      nombres: "",
      apellidos: "",
      fechaNacimiento: "",
      edad: "",
      estadoCivil: "1",
      sexo: "1",
      direccion: "",
      telefono: "",
      telefonoContacto: "",
      idEstado: "",
      idMunicipio: "",
      idCiudad: "",
      idLocalidad: "",
      nacionalidad: "VENEZOLANA",
      grupoSanguineo: "",
      estatura: "",
      peso: "",
      usaLentes: "2",
      tallaCalzado: "",
      tallaPantalon: "",
      tallaCamisa: "",
      discapacitado: "2",
      codConapdis: "",
      patologia: "",
      foto: "",
      codUnidadFuncional: "",
      nombreUnidadFuncional: "",
      codDepartamento: "",
      nombreDepartamento: "",
      codCargo: "",
      nombreCargo: "",
      status: "Activo",
      fechaIngreso: "",
      antiguedad: "",
      pagadoBanco: false,
      codBanco: "",
      nombreBanco: "",
      tipoCuenta: "1",
      numCuenta: "",
      desCuenta: "",
      codFideicomiso: "",
      nombreFideicomiso: "",
      numCuentaFideicomiso: "",
      codGrupoNomina: "",
      nombreGrupoNomina: "",
      fecUltVacaciones: "",
      fecIngresoVacaciones: "",
      fecAdmonPublica: "",
      vacacionesVencidas: "0",
      diasVacPendientes: "0",
      fechaEgreso: "",
      motivoEgreso: "",
      salarioMensual: "",
      idGrado: "",
      idEspecialidad: "",
      idMencion: ""
    });

    if (fotoPreview) {
      URL.revokeObjectURL(fotoPreview);
    }
    setFoto(null);
    setFotoPreview(null);
    setFotoNombre("");

    setGradoInstruccion([]);
    setEspecialidades([]);
    setMenciones([]);
    setEstados([]);
    setMunicipios([]);
    setCiudades([]);
    setLocalidades([]);

    setDatosLocales({
      familiares: [],
      cargos: [],
      cursos: [],
      profesiones: [],
      vacaciones: [],
      constantes: [],
      conceptos: [],
      conceptosPagos: [],
      acumulados: []
    });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.operacion === 1) {
          resetearTodo();
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">
          {props.operacion === 1 ? 'Registro de Integrantes' :
            props.operacion === 2 ? 'Edición de Integrantes' :
              props.operacion === 3 ? 'Eliminar Integrante' :
                props.operacion === 4 ? 'Consulta de Integrantes' : 'Integrantes'}
        </h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2">
        <ul className="nav d-flex flex-wrap gap-1 align-items-center" id="ex-with-icons" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active bg-blue-100 text-light rounded h-100"
              id="integrante-tab"
              data-bs-toggle="tab"
              data-bs-target="#integrante-tab-pane"
              type="button"
              role="tab"
            >
              Integrante
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-200 text-light rounded"
              id="otrosDatos-tab"
              data-bs-toggle="tab"
              data-bs-target="#otrosDatos-tab-pane"
              type="button"
              role="tab"
            >
              Otros Datos
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-300 text-light rounded"
              id="familiares-tab"
              data-bs-toggle="tab"
              data-bs-target="#familiares-tab-pane"
              type="button"
              role="tab"
            >
              Familiares
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-300 text-light rounded"
              id="datos-laborables"
              data-bs-toggle="tab"
              data-bs-target="#datos-laborables-pane"
              type="button"
              role="tab"
            >
              Datos Laborables
            </button>
          </li>
          {props.operacion !== 1 && <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-400 text-light rounded"
              id="vacaciones-tab"
              data-bs-toggle="tab"
              data-bs-target="#vacaciones-tab-pane"
              type="button"
              role="tab"
            >
              Vacaciones
            </button>
          </li>}
          {props.operacion !== 1 && <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-500 text-light rounded"
              id="constNomina-tab"
              data-bs-toggle="tab"
              data-bs-target="#constNomina-tab-pane"
              type="button"
              role="tab"
            >
              Const. Nomina
            </button>
          </li>}
          {props.operacion !== 1 && <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-600 text-light rounded"
              id="coneptNomina-tab"
              data-bs-toggle="tab"
              data-bs-target="#coneptNomina-tab-pane"
              type="button"
              role="tab"
            >
              Concept. Nomina
            </button>
          </li>}
          {props.operacion !== 1 && <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-700 text-light rounded"
              id="visualizarNomina-tab"
              data-bs-toggle="tab"
              data-bs-target="#visualizarNomina-tab-pane"
              type="button"
              role="tab"
            >
              Visualizar Nomina
            </button>
          </li>}
          {props.operacion !== 1 && <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-800 text-light rounded"
              id="acumuGenerales-tab"
              data-bs-toggle="tab"
              data-bs-target="#acumuGenerales-tab-pane"
              type="button"
              role="tab"
            >
              Acumu. Generales
            </button>
          </li>}
          {props.operacion !== 1 && <li className="nav-item" role="presentation">
            <button
              className="nav-link bg-blue-900 text-light rounded"
              id="conceptosPagos-tab"
              data-bs-toggle="tab"
              data-bs-target="#conceptosPagos-tab-pane"
              type="button"
              role="tab"
            >
              Conceptos Pagos
            </button>
          </li>}
        </ul>

        <div className="tab-content" id="myTabContent">
          {/* Pestaña Integrante */}
          <div
            className="tab-pane fade show active"
            id="integrante-tab-pane"
            role="tabpanel"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <fieldset className="col-10 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="m-0 w-auto float-none">Informacion Personal</legend>

                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    label='Cod. Integrante:'
                    name="codIntegrante"
                    value={integrante.codIntegrante}
                    onChange={handleInputChange}
                    disabled={props.operacion !== 1}
                  />
                </div>
                <div className="col-2 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Cedula:'
                    name="cedula"
                    value={integrante.cedula}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-2 m-0 p-0 pl-2">
                  <Input
                    label='RIF:'
                    name="rif"
                    value={integrante.rif}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-5 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Correo Electronico:'
                    name="correo"
                    value={integrante.correo}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>

                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    label='Nombres:'
                    name="nombres"
                    value={integrante.nombres}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Apellidos:'
                    name="apellidos"
                    value={integrante.apellidos}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Fecha de nacimiento:'
                    type='date'
                    name="fechaNacimiento"
                    value={integrante.fechaNacimiento}
                    onChange={(e) => {
                      handleInputChange(e);
                      setIntegrante(prev => ({
                        ...prev,
                        edad: calcularEdad(e.target.value)
                      }));
                    }}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-2 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Edad'
                    name="edad"
                    value={integrante.edad}
                    disabled
                  />
                </div>

                <div className="col-6 m-0 mb-2 p-0 d-flex gap-2">
                  <span className="fw-bold">Edo. Civil:</span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Soltera/o'
                      name='estadoCivil'
                      id='estadoCivil1'
                      value="1"
                      checked={integrante.estadoCivil === "1"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Casada/o'
                      name='estadoCivil'
                      id='estadoCivil2'
                      value="2"
                      checked={integrante.estadoCivil === "2"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Divorciada/o'
                      name='estadoCivil'
                      id='estadoCivil3'
                      value="3"
                      checked={integrante.estadoCivil === "3"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Viuda/o'
                      name='estadoCivil'
                      id='estadoCivil4'
                      value="4"
                      checked={integrante.estadoCivil === "4"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                </div>

                <div className="col-3 m-0 mb-2 p-0 pl-2 d-flex gap-2">
                  <span className="fw-bold">Sexo:</span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Femenino'
                      name='sexo'
                      id='sexo1'
                      value="1"
                      checked={integrante.sexo === "1"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Masculino'
                      name='sexo'
                      id='sexo2'
                      value="2"
                      checked={integrante.sexo === "2"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                </div>

                <div className="col-6 m-0 mb-2 p-0">
                  <Input
                    label='Dirección'
                    name="direccion"
                    value={integrante.direccion}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Teléfono'
                    name="telefono"
                    value={integrante.telefono}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Contacto'
                    name="telefonoContacto"
                    value={integrante.telefonoContacto}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>

                <div className="col-3 m-0 mb-2 p-0">
                  <Select
                    label='Estado:'
                    name="idEstado"
                    value={integrante.idEstado}
                    onChange={handleEstadoChange}
                    disabled={props.operacion === 4}
                  >
                    <option value="">Seleccione...</option>
                    {estados.map(estado => (
                      <option key={estado.idestado} value={estado.idestado}>
                        {estado.nombre}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Select
                    label='Municipio:'
                    name="idMunicipio"
                    value={integrante.idMunicipio}
                    onChange={handleMunicipioChange}
                    disabled={props.operacion === 4}
                  >
                    <option value="">Seleccione...</option>
                    {municipios.map(mun => (
                      <option key={mun.idmunicipio} value={mun.idmunicipio}>
                        {mun.nombre}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Select
                    label='Ciudad:'
                    name="idCiudad"
                    value={integrante.idCiudad}
                    onChange={handleCiudadChange}
                    disabled={props.operacion === 4}
                  >
                    <option value="">Seleccione...</option>
                    {ciudades.map(ciudad => (
                      <option key={ciudad.idciudad} value={ciudad.idciudad}>
                        {ciudad.nombre}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Select
                    label='Localidad:'
                    name="idLocalidad"
                    value={integrante.idLocalidad}
                    onChange={handleLocalidadChange}
                    disabled={props.operacion === 4}
                  >
                    <option value="">Seleccione...</option>
                    {localidades.map(loc => (
                      <option key={loc.idciudadxlocalidad} value={loc.idciudadxlocalidad}>
                        {loc.nombre}
                      </option>
                    ))}
                  </Select>
                </div>

                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    label='Nacionalidad:'
                    name="nacionalidad"
                    value={integrante.nacionalidad}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Grupo Sanguineo:'
                    name="grupoSanguineo"
                    value={integrante.grupoSanguineo}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Estatura:'
                    name="estatura"
                    value={integrante.estatura}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Peso:'
                    name="peso"
                    value={integrante.peso}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>

                <div className="col-3 m-0 mb-2 p-0 d-flex gap-2">
                  <span className="fw-bold">Usa lentes:</span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Si'
                      name='usaLentes'
                      id='lentes1'
                      value="1"
                      checked={integrante.usaLentes === "1"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='No'
                      name='usaLentes'
                      id='lentes2'
                      value="2"
                      checked={integrante.usaLentes === "2"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Talla Calzado:'
                    name="tallaCalzado"
                    value={integrante.tallaCalzado}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Talla Pantalon:'
                    name="tallaPantalon"
                    value={integrante.tallaPantalon}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Talla Camisa:'
                    name="tallaCamisa"
                    value={integrante.tallaCamisa}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>

                <div className="col-3 m-0 p-0 d-flex gap-2">
                  <span className="fw-bold">Discapacitado:</span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Si'
                      name='discapacitado'
                      id='discapacitado1'
                      value="1"
                      checked={integrante.discapacitado === "1"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='No'
                      name='discapacitado'
                      id='discapacitado2'
                      value="2"
                      checked={integrante.discapacitado === "2"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4}
                    />
                  </div>
                </div>
                <div className="col-9 m-0 p-0 pl-2">
                  <Input
                    label='Patología:'
                    name="patologia"
                    value={integrante.patologia}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
              </fieldset>

              {/* Área de la foto */}
              <div className="col-2 m-0 p-0 d-flex flex-column align-items-center justify-content-center">
                <div
                  className="foto-container mb-2"
                  style={{
                    width: '150px',
                    height: '150px',
                    border: '2px dashed #ccc',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    cursor: props.operacion === 4 ? 'default' : 'pointer',
                    backgroundColor: '#f8f9fa'
                  }}
                  onClick={props.operacion !== 4 ? handleFotoClick : undefined}
                >
                  {fotoPreview ? (
                    <img
                      src={fotoPreview}
                      alt="Vista previa"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <i className="fa fa-user text-center fs-1" style={{ color: '#6c757d' }}></i>
                  )}
                </div>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  accept="image/jpeg,image/jpg,image/png,image/gif,image/bmp"
                  onChange={handleFotoChange}
                  disabled={props.operacion === 4}
                />
                {props.operacion !== 4 && props.operacion === 1 && (
                  <>
                    <div className="col-auto m-0 p-0">
                      <PrimaryButton onClick={handleFotoClick}>
                        {fotoPreview ? 'Cambiar Foto' : 'Seleccionar Foto'}
                      </PrimaryButton>
                    </div>
                    {fotoNombre && (
                      <small className="text-muted mt-1">{fotoNombre}</small>
                    )}
                  </>
                )}
              </div>

              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="m-0 w-auto float-none">Informacion Laboral</legend>

                <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
                  <div className="col-3 m-0 p-0">
                    <SearchInput
                      label='Cod. Unidad Funcional:'
                      name="codUnidadFuncional"
                      value={integrante.codUnidadFuncional}
                      onChange={handleInputChange}
                      onClickButton={() => setMostrarUnidadFuncional(true)}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <Input
                    label='Nombre:'
                    value={integrante.nombreUnidadFuncional}
                    disabled
                  />
                </div>

                <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
                  <div className="col-3 m-0 p-0">
                    <SearchInput
                      label='Cod. Departamento:'
                      name="codDepartamento"
                      value={integrante.codDepartamento}
                      onChange={handleInputChange}
                      onClickButton={() => setMostrarDepartamento(true)}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <Input
                    label='Nombre:'
                    value={integrante.nombreDepartamento}
                    disabled
                  />
                </div>

                <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
                  <div className="col-3 m-0 p-0">
                    <SearchInput
                      label='Cod. Cargo:'
                      name="codCargo"
                      value={integrante.codCargo}
                      onChange={handleInputChange}
                      onClickButton={() => setMostrarCargo(true)}
                      disabled={props.operacion === 4}
                    />
                  </div>
                  <Input
                    label='Nombre:'
                    value={integrante.nombreCargo}
                    disabled
                  />
                </div>

                <div className="col-3 m-0 p-0">
                  <Input
                    label='Status:'
                    name="status"
                    value={integrante.status}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label='Fecha de Ingreso'
                    type='date'
                    name="fechaIngreso"
                    value={integrante.fechaIngreso}
                    onChange={(e) => {
                      handleInputChange(e);
                      setIntegrante(prev => ({
                        ...prev,
                        antiguedad: calcularAntiguedad(e.target.value, prev.fechaEgreso)
                      }));
                    }}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label='Antigüedad'
                    value={integrante.antiguedad}
                    disabled
                  />
                </div>
              </fieldset>
            </div>
          </div>

          {/* Pestaña Otros Datos */}
          <div
            className="tab-pane fade"
            id="otrosDatos-tab-pane"
            role="tabpanel"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap justify-content-between">
              <div className="col-auto m-0 p-0">
                <Checkbox
                  label='Pagado Por Bancos'
                  name="pagadoBanco"
                  checked={integrante.pagadoBanco}
                  onChange={handleInputChange}
                  disabled={props.operacion === 4}
                />
              </div>

              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="w-auto m-0 float-none">Datos Banco</legend>

                <div className="col-2 m-0 mb-2 p-0">
                  <SearchInput
                    label='Cod. Banco:'
                    name="codBanco"
                    value={integrante.codBanco}
                    onChange={handleInputChange}
                    onClickButton={() => setMostrarBanco(true)}
                    disabled={props.operacion === 4 || !integrante.pagadoBanco}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Nombre:'
                    value={integrante.nombreBanco}
                    disabled
                  />
                </div>
                <div className="col-6 m-0 p-0 pl-2 d-flex gap-2">
                  <span className="fw-bold">Tipo Cuenta:</span>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Cuenta Corriente'
                      name='tipoCuenta'
                      id='tipoCuenta1'
                      value="1"
                      checked={integrante.tipoCuenta === "1"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4 || !integrante.pagadoBanco}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label='Cuenta ahorro'
                      name='tipoCuenta'
                      id='tipoCuenta2'
                      value="0"
                      checked={integrante.tipoCuenta === "0"}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4 || !integrante.pagadoBanco}
                    />
                  </div>
                </div>

                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    label='Num. Cuenta:'
                    name="numCuenta"
                    value={integrante.numCuenta}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4 || !integrante.pagadoBanco}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Des. Cuenta:'
                    name="desCuenta"
                    value={integrante.desCuenta}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4 || !integrante.pagadoBanco}
                  />
                </div>

                <div className="col-12 m-0 p-0 d-flex gap-2">
                  <div className="col-2 m-0 p-0">
                    <SearchInput
                      label='Fideicomiso:'
                      name="codFideicomiso"
                      value={integrante.codFideicomiso}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4 || !integrante.pagadoBanco}
                    />
                  </div>
                  <div className="col m-0 p-0">
                    <Input
                      label='Nombre:'
                      value={integrante.nombreFideicomiso}
                      disabled
                    />
                  </div>
                  <div className="col m-0 p-0">
                    <Input
                      label='Num. Cuenta Fideicomiso:'
                      name="numCuentaFideicomiso"
                      value={integrante.numCuentaFideicomiso}
                      onChange={handleInputChange}
                      disabled={props.operacion === 4 || !integrante.pagadoBanco}
                    />
                  </div>
                </div>
              </fieldset>

              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="w-auto m-0 float-none">Datos Nomina</legend>

                <div className="col-3 m-0 mb-2 p-0">
                  <SearchInput
                    label='Cod. Grupo Nomina:'
                    name="codGrupoNomina"
                    value={integrante.codGrupoNomina}
                    onChange={handleInputChange}
                    onClickButton={() => setMostrarGrupoNomina(true)}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-9 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Nombre:'
                    value={integrante.nombreGrupoNomina}
                    disabled
                  />
                </div>

                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    label='Fec. Ult. Vacaciones:'
                    type='date'
                    name="fecUltVacaciones"
                    value={integrante.fecUltVacaciones}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Fec Ingreso Para Vacaciones:'
                    type='date'
                    name="fecIngresoVacaciones"
                    value={integrante.fecIngresoVacaciones}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mr-2 mb-2 p-0 pl-2">
                  <Input
                    label='Fec. Admón Pública:'
                    type='date'
                    name="fecAdmonPublica"
                    value={integrante.fecAdmonPublica}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>

                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    label='Vacaciones vencidas:'
                    name="vacacionesVencidas"
                    value={integrante.vacacionesVencidas}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Dias de Vacaciones pendientes:'
                    name="diasVacPendientes"
                    value={integrante.diasVacPendientes}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
                <div className="col-2 m-0 mb-2 p-0 pl-2">
                  <Input
                    label='Dias de Egreso:'
                    name="fechaEgreso"
                    type="date"
                    value={integrante.fechaEgreso}
                    onChange={(e) => {
                      handleInputChange(e);
                      setIntegrante(prev => ({
                        ...prev,
                        antiguedad: calcularAntiguedad(prev.fechaIngreso, e.target.value)
                      }));
                    }}
                    disabled={props.operacion === 4}
                  />
                </div>

                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea
                    label='Motivo de Egreso:'
                    style={{ height: 70 }}
                    name="motivoEgreso"
                    value={integrante.motivoEgreso}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>

                <div className="col-3 m-0 p-0">
                  <Input
                    label='Salario Mensual:'
                    name="salarioMensual"
                    value={integrante.salarioMensual}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  />
                </div>
              </fieldset>

              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="m-0 w-auto float-none">Datos Laborales</legend>

                <div className="col-4 m-0 p-0">
                  <Select
                    label='Grado de Instrucción:'
                    onChange={handleGradoChange}
                    value={integrante.idGrado}
                    disabled={props.operacion === 4}
                  >
                    <option value="">Seleccione...</option>
                    {gradoInstruccion.map(grado => (
                      <option key={grado.idgradoinstruccion} value={grado.idgradoinstruccion}>
                        {grado.descripcion}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Select
                    label='Especialidad:'
                    onChange={handleEspecialidadChange}
                    value={integrante.idEspecialidad}
                    disabled={props.operacion === 4}
                  >
                    <option value="">Seleccione...</option>
                    {especialidades.map(esp => (
                      <option key={esp.idespecialidad} value={esp.idespecialidad}>
                        {esp.descripcion}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Select
                    label='Mención:'
                    name="idMencion"
                    value={integrante.idMencion}
                    onChange={handleInputChange}
                    disabled={props.operacion === 4}
                  >
                    <option value="">Seleccione...</option>
                    {menciones.map(men => (
                      <option key={men.idmencion} value={men.idmencion}>
                        {men.descripcion}
                      </option>
                    ))}
                  </Select>
                </div>
              </fieldset>
            </div>
          </div>

          {/* Pestañas de Tablas - Solo visibles para operacion 1 (inserción) */}
          {props.operacion === 1 && (
            <>
              <div className="tab-pane fade" id="familiares-tab-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Datos de Los Familiares</legend>
                  <TablaFamiliares
                    modo="local"
                    operacionintegrante={props.operacion}
                    codIntegrante={integrante.codIntegrante}
                    onDataChange={(data) => {
                      handleDataFromChild('familiares', data);
                    }}
                  />
                </fieldset>
              </div>

              <div className="tab-pane fade" id="datos-laborables-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Datos Laborales del Integrante</legend>
                  <TablaDatosLaborales
                    modo="local"
                    operacionintegrante={props.operacion}
                    codIntegrante={integrante.codIntegrante}
                    onDataChange={(tipo, data) => {
                      handleDataFromChild(tipo, data);
                    }}
                  />
                </fieldset>
              </div>
            </>
          )}

          {/* Pestañas de solo consulta para operaciones 2, 3, 4 */}
          {props.operacion !== 1 && (
            <>
              <div className="tab-pane fade" id="familiares-tab-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Datos de Los Familiares</legend>
                  <TablaFamiliares
                    modo="bd"
                    operacionintegrante={props.operacion}
                    codIntegrante={integrante.codIntegrante}
                  />
                </fieldset>
              </div>

              <div className="tab-pane fade" id="datos-laborables-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Datos Laborales del Integrante</legend>
                  <TablaDatosLaborales
                    modo="bd"
                    operacionintegrante={props.operacion}
                    codIntegrante={integrante.codIntegrante}
                  />
                </fieldset>
              </div>

              <div className="tab-pane fade" id="vacaciones-tab-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Datos de Las Vacaciones</legend>
                  <TablaVacaciones
                    modo="bd"
                    codIntegrante={integrante.codIntegrante}
                  />
                </fieldset>
              </div>

              <div className="tab-pane fade" id="constNomina-tab-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Valor de las constantes</legend>
                  <TablaConstantesNomina
                    modo="bd"
                    codIntegrante={integrante.codIntegrante}
                  />
                </fieldset>
              </div>

              <div className="tab-pane fade" id="coneptNomina-tab-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Status de los Conceptos</legend>
                  <TablaConceptoNomina
                    modo="bd"
                    codIntegrante={integrante.codIntegrante}
                  />
                </fieldset>
              </div>

              <div className="tab-pane fade" id="visualizarNomina-tab-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Vizualizar Nomina</legend>
                  <TablaVisualizarNomina
                    modo="bd"
                    codIntegrante={integrante.codIntegrante}
                  />
                </fieldset>
              </div>

              <div className="tab-pane fade" id="acumuGenerales-tab-pane" role="tabpanel">
                <TablaAcumuGenerales
                  modo="bd"
                  codIntegrante={integrante.codIntegrante}
                />
              </div>

              <div className="tab-pane fade" id="conceptosPagos-tab-pane" role="tabpanel">
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="w-auto m-0 float-none">Status de los conceptos</legend>
                  <TablaConceptosPagos
                    modo="bd"
                    codIntegrante={integrante.codIntegrante}
                  />
                </fieldset>
              </div>
            </>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        {props.operacion !== 4 && (
          <button
            type="button"
            onClick={guardarTodo}
            className={`btn btn-sm rounded-pill col-md-2 ${props.operacion === 3 ? 'btn-danger' : 'btn-success'}`}
            disabled={activate}
          >
            {activate ? 'Procesando...' : props.operacion === 3 ? 'Eliminar' : 'Aceptar'}
          </button>
        )}
        <button
          type="button"
          onClick={salir}
          className="btn btn-sm rounded-pill col-md-2 btn-danger"
        >
          {props.operacion === 4 ? 'Cerrar' : 'Cancelar'}
        </button>
      </Modal.Footer>

      <CatalogoUnidadFuncional
        show={mostrarUnidadFuncional}
        onHideCancela={() => setMostrarUnidadFuncional(false)}
        codNomina={integrante.codNomina}
        onHideAcepta={onHideAceptaUnidadFuncional}
      />

      <CatalogoDepartamento
        show={mostrarDepartamento}
        onHideCancela={() => setMostrarDepartamento(false)}
        codNomina={integrante.codNomina}
        onHideAcepta={onHideAceptaDepartamento}
      />

      <CatalogoCargo
        show={mostrarCargo}
        onHideCancela={() => setMostrarCargo(false)}
        codNomina={integrante.codNomina}
        onHideAcepta={onHideAceptaCargo}
      />

      <CatalogoBancoNomina
        show={mostrarBanco}
        onHideCancela={() => setMostrarBanco(false)}
        codNomina={integrante.codNomina}
        onHideAcepta={onHideAceptaBanco}
      />

      <CatalogoGrupoNomina
        show={mostrarGrupoNomina}
        onHideCancela={() => setMostrarGrupoNomina(false)}
        codNomina={integrante.codNomina}
        onHideAcepta={onHideAceptaGrupoNomina}
      />
    </Modal>
  );
}